import { TICKET_CALENDAR_SEARCH_START_LOADING, TICKET_CALENDAR_SEARCH_END_LOADING, TICKET_CALENDAR_SEARCH_LOADED, SET_TICKET_CALENDAR_FILTER } from "../constants/TicketCalendarConstants";
import { getApiData, postApiJsonData, downloadFile } from "../utils/index";
import * as commonActions from "./CommonActions";

export function loadTicketCalendarSearch(userId, filters, navigate) {
    return async (dispatch) => {
        await dispatch({ type: TICKET_CALENDAR_SEARCH_START_LOADING });
        try {
            filters.userId = userId;
            var data = await postApiJsonData("Ticket/GetTicketCalendarFBO", filters, null);
            if(data.success) {
                await dispatch({
                    type: TICKET_CALENDAR_SEARCH_LOADED,
                    payload: data.responseEntities[0]
                });
            } else {
                if(data.errorCode == "401") {
                    navigate('/not-authorized/');
                }
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            await dispatch({ type: TICKET_CALENDAR_SEARCH_END_LOADING });
        } catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: TICKET_CALENDAR_SEARCH_END_LOADING });
        }
    };
}

export function setTicketCalendarFilter(filter) {
    return async (dispatch) => {
        await dispatch({
            type: SET_TICKET_CALENDAR_FILTER,
            payload: filter
        });
    };
}
